module.exports = __webpack_public_path__ + "static/media/info_clear_4.d47b5bcc.jpg";